import "./BookNow.module.css";
import Header from "@/reusable_sections/Header";
import Banner from "./sections/Banner";
import StartYourWasteRecyclingServiceToday from "./sections/StartYourWasteRecyclingServiceToday";
import SignUpForm from "./sections/SignUpForm";
import SignUpFormWithNeighborInfo from "./sections/SignUpFormWithNeighborInfo";
import InstagramFeed from "./sections/InstagramFeed";
import PopUp from "./sections/PopUp";
import AboutColumbiaValleyWasteRecycling from "./sections/AboutColumbiaValleyWasteRecycling";
import Footer from "@/reusable_sections/Footer";
export default function BookNowPage() {
  return <div>
      <Header />
      <Banner />
      <StartYourWasteRecyclingServiceToday />
      <SignUpForm />
      <SignUpFormWithNeighborInfo />
      <InstagramFeed />
      <PopUp />
      <AboutColumbiaValleyWasteRecycling />
      <Footer />
    </div>;
}